import { App, AppSubroute } from '@ps20-frontend/frontend-models';
import { ProgressbarItem } from './progressbarItem';

export enum ProgressbarItemsEnum {
  EMPTY = '',
  EINGABE = 'eingabe',
  ANGEBOT = 'angebot',
  ANTRAG_STELLEN = 'antrag_stellen',
}

export class ProgressbarItems {
  static readonly dashboardProgressbarItemsWithText: ProgressbarItem[] = [];
  static readonly checkoutAngebotProgressbarItemsWithText: ProgressbarItem[] = [];

  static generateProgressbarItems(appName: App): ProgressbarItem[] {
    return [
      {
        id: ProgressbarItemsEnum.EINGABE,
        title: 'Angaben',
        navigationAction: { appId: appName, subroute: AppSubroute.TAA_EINGABE },
      },
      {
        id: ProgressbarItemsEnum.ANGEBOT,
        title: 'Angebot',
        navigationAction: { appId: appName, subroute: AppSubroute.TAA_ANGEBOT },
      },
    ];
  }
}

export function getProgressbarItemIdForRoute(appId: App, subroute = ''): ProgressbarItemsEnum {
  const appProgressbarItems = getProgressbarItemsForApp(appId);
  const mappedMenuItem = appProgressbarItems.find(menuItem => {
    return (
      menuItem.navigationAction.appId === appId &&
      subroute.includes(menuItem.navigationAction.subroute)
    );
  });

  if (!mappedMenuItem) {
    return ProgressbarItemsEnum.EMPTY;
  }

  return mappedMenuItem.id;
}

export function getProgressbarItemsForApp(appId: App): ProgressbarItem[] {
  switch (appId) {
    case App.SHOP_DASHBOARD:
      return ProgressbarItems.dashboardProgressbarItemsWithText;
    case App.SHOP_CHECKOUT:
      return ProgressbarItems.checkoutAngebotProgressbarItemsWithText;
  }

  if (Object.values(App).some(appName => appName === appId)) {
    return ProgressbarItems.generateProgressbarItems(appId);
  }

  return [];
}
